import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from "ngx-spinner";
import { NgxFileDropEntry, FileSystemFileEntry, FileSystemDirectoryEntry } from 'ngx-file-drop';
import { HttpErrorResponse, HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/core-services/auth.service';
import { PortService } from 'src/app/core-services/port.service';
import { FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { RateRequestVM } from 'src/app/models/ReteRequest';
import { RateRequestService } from 'src/app/core-services/raterequest.services';
import { toInteger } from '@ng-bootstrap/ng-bootstrap/util/util';
import { Router, ActivatedRoute } from '@angular/router';
import 'jquery';
import * as $ from 'jquery';
import { BookingService } from '../../landing/services/booking.service';
import { RaterequestStatus, UserRole, UserSelectedPlan } from 'src/app/Enum/Enum';

export interface CargoCondition {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-rate-request',
  templateUrl: './rate-request.component.html',
  styleUrls: ['./rate-request.component.scss']
})

export class RateRequestComponent implements OnInit {
  stateParams: any;
  countries: any = [];
  ratedropdown: any = [];
  fromport: any = [];
  toport: any = [];
  cargoTypes = [];
  cargoSegments = [];
  cargoSegmentList = [];
  isauto = true;
  isbreakbulk = false;
  ishighandhevy = false;
  submitted = false;
  minDate: Date;
  rageYears: string;
  shippinglineslist: any;
  readonly: boolean = false;
  newReadonly: boolean = false;
  descriptionLength = false;
  totalChar = 250;
  fromCountryId: number = 0;
  toCountryId: number = 0;
  // selectedPlan: number;
  loggedInUser: any;
  lengthvalid:boolean=false;
  widthvalid:boolean=false;
  heightvalid:boolean=false;
  cargoConditions: CargoCondition[] = [
    { value: '1', viewValue: 'New' },
    { value: '2', viewValue: 'Used' }
  ];

  fileNames: any[] = [];
  formData: FormData;
  downloadBaseUrl:string;
  cargoMovementStatusList = [];

  ratereqform = this.fb.group({
    id: [''],
    fromcountryid: ['', Validators.required],
    fromportid: ['', Validators.required],
    tocountryid: ['', Validators.required],
    toportid: ['', Validators.required],
    whencancargolanport: ['', Validators.required],
    cargoclass: ['', Validators.required],
    cargoconsigment: ['', Validators.required],
    condition: ['', Validators.required],
    cargoMovementStatus: ['', Validators.required],
    noofunits: ['', [Validators.required]],
    length: ['', [Validators.required]],
    width: ['', Validators.required],
    height: ['', Validators.required],
    weight: ['', [Validators.required]],
    Sqm: ['', [Validators.required]],
    cbm: ['', [Validators.required]],
    shippinglineId: [''],
    description: ['', Validators.required],
    phoneNumber: ['', Validators.required],
    email: ['', Validators.required],
    firstname: ['',Validators.required],
    lastname: ['',Validators.required]
  });
  showUserDetails=false;
  constructor(private http: HttpClient, private fb: FormBuilder, private bookingService: BookingService, private router: Router, private activatedRoute: ActivatedRoute, private toastr: ToastrService, private spinner: NgxSpinnerService, private authenticationService: AuthService, private raterequestservice: RateRequestService, private portservice: PortService) {
    this.activatedRoute.paramMap.subscribe((params: any) => {
      this.stateParams = params.params;
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.downloadBaseUrl = environment.apiUrl+"api/Upload/DownloadFreightDocument/";
    });

    // var currentUser = localStorage.getItem('currentUser');
    // if (currentUser != null && currentUser != undefined) {

    //   this.loggedInUser = JSON.parse(currentUser);
    //   if (this.loggedInUser != null && this.loggedInUser.usersDetailsVM != null) {
    //     if (this.loggedInUser.usersDetailsVM.userRole != null && this.loggedInUser.usersDetailsVM.userRole != '') {
    //       if (this.loggedInUser.usersDetailsVM.userRole != UserRole.SuperAdmin) {
    //         this.selectedPlan = this.loggedInUser.usersDetailsVM.planId;
    //       }
    //     }
    //   }
    // }


    if (this.stateParams != null && this.stateParams.fromPortId > 0 && this.stateParams.toPortId > 0) {
      this.getCountryByPortId(this.stateParams.fromPortId, this.stateParams.toPortId);
      this.newReadonly = true;
    }
  }

  ngOnInit() {
    let userDetail=  JSON.parse(String(localStorage.getItem('currentUser')));
if(userDetail){
  this.showUserDetails=true;
 this.ratereqform.patchValue({
  email: userDetail.usersDetailsVM.email,
  firstname: userDetail.usersDetailsVM.firstName,
  lastname: userDetail.usersDetailsVM.lastName
});
}
   
    this.getMasterCargoMovementStatus();
    this.getCountries();
    this.getshippingline();
    this.getMasterCargoClass();
    this.getMasterCargoSegments();

    //this.getportbycountryid(3);
    this.minDate = new Date();
    this.rageYears = this.minDate.getUTCFullYear() + ':' + (this.minDate.getUTCFullYear() + 50);
  }

  public hasError = (controlName: string, errorName: string) => {
    return this.ratereqform.controls[controlName].hasError(errorName);
  }
  onKeyPress() {
    this.descriptionLength = true;
    const charLength = this.ratereqform.controls.description.value.length;
    this.totalChar = 250 - charLength;
    if (this.totalChar === 250) {
      this.descriptionLength = false;
    }
  }
  getCountries() {
    this.spinner.show();
    //this.raterequestservice.getRateRequestDropdown().subscribe(data => this.ratedropdown.push(...data));       
    this.authenticationService.getCountry().subscribe((response: any) => {
      if (response != null && response.content != null) {
        this.countries = response.content;
        if (this.fromCountryId > 0 && this.toCountryId > 0) {
          var fromCountry = this.countries.filter(x => x.id == this.fromCountryId);
          var toCountry = this.countries.filter(x => x.id == this.toCountryId);
          this.ratereqform.controls.fromcountryid.setValue(fromCountry[0]);
          this.ratereqform.controls.tocountryid.setValue(toCountry[0]);
        }
        if (this.stateParams != null && this.stateParams.id != null && this.stateParams.id != undefined && this.stateParams.id != 0) {
          this.getRatedetails();
        }
        // this.getRatedetails();
      }
      this.spinner.hide();
    })
  }

  getportbycountryid(countryid, frmport) {
    this.portservice.GetPortByCountryId(countryid.value.id).
      subscribe((response: any) => {
        if (response != null && response.content != null) {
          if (frmport == 'frmport') {
            this.fromport = response.content;
            this.ratereqform.controls.fromportid.setValue("");
          }
          else {
            this.toport = response.content;
            this.ratereqform.controls.toportid.setValue("");
          }
        }
      })

  }

  getCountryByPortId(fromPortId, toPortId) {
    this.portservice.getSelectedCountryByPortId(fromPortId, toPortId).
      subscribe((response: any) => {
        if (response != null && response.content != null && response.content.length > 0) {
          response.content.forEach(element => {
            if (element != null) {
              if (element.portId == this.stateParams.fromPortId) {
                this.fromCountryId = element.countryId;
              }
              else if (element.portId == this.stateParams.toPortId) {
                this.toCountryId = element.countryId;
              }
              if (this.fromCountryId > 0 && this.toCountryId > 0) {
                this.getPortsBycountryId(this.fromCountryId, this.toCountryId)
              }
            }
          });
        }
      })
  }

  getPortsBycountryId(fromCountryid, toCountryid) {
    this.spinner.show();
    this.bookingService.getPortsByTowCountryId(fromCountryid, toCountryid).
      subscribe((response: any) => {

        if (response != null && response.content != null && response.content.length > 0) {
          this.fromport = response.content.filter(x => x.portCountryId == fromCountryid);
          this.toport = response.content.filter(x => x.portCountryId == toCountryid);
          if (this.stateParams.fromPortId > 0 && this.stateParams.toPortId > 0) {
            var selectedFromPorts = this.fromport.filter(x => x.id == this.stateParams.fromPortId);
            var selectedToPorts = this.toport.filter(x => x.id == this.stateParams.toPortId);
            if (selectedFromPorts != null && selectedFromPorts.length > 0) {
              this.ratereqform.controls.fromportid.setValue(selectedFromPorts[0]);
            }
            if (selectedToPorts != null && selectedToPorts.length > 0) {
              this.ratereqform.controls.toportid.setValue(selectedToPorts[0]);
            }
          }
        }
        this.spinner.hide();
      })
  }


  getdropdownvalue(event) {
    if (event.target.value == "2") {
      this.isauto = false;
      this.isbreakbulk = true;
      this.ishighandhevy = false;
    }
    else if (event.target.value == "3") {
      this.isauto = false;
      this.isbreakbulk = false;
      this.ishighandhevy = true;
    }
    else {
      this.isauto = true;
      this.isbreakbulk = false;
      this.ishighandhevy = false;
    }
  }

  getMasterCargoMovementStatus() {
    this.spinner.show();
    this.bookingService.getMasterCargoMovementStatus().subscribe((response: any) => {
      if (response != null && response.content != null && response.content.length > 0) {
        this.cargoMovementStatusList = response.content;
      }
      this.spinner.hide();
    })
  }

  getMasterCargoClass() {
    this.spinner.show();
    this.bookingService.getMasterCargoClass().subscribe((response: any) => {
      if (response != null && response.content != null && response.content.length > 0) {
        this.cargoTypes = response.content;
      }
      this.spinner.hide();
    })
  }

  getMasterCargoSegments() {
    this.spinner.show();
    this.bookingService.getMasterCargoSegments().subscribe((response: any) => {
      if (response != null && response.content != null && response.content.length > 0) {
        this.cargoSegments = response.content;
        this.cargoSegmentList = response.content;
      }
      this.spinner.hide();
    })
  }

  getCargoSegment(event) {
    if (event != null && event != undefined) {
      if (event.value != null) {
        this.cargoSegments = this.cargoSegmentList.filter(x => x.cargoClassId == event.value.id);
        this.ratereqform.controls.cargoconsigment.setValue("");
      }
    }
  }

  onsubmit() {
    this.submitted = true;
    if (this.ratereqform.invalid) {
      // this.toastr.warning('Please Enter All the Required Fields.', 'Oops !');
      return;
    }
    else if( parseFloat(this.ratereqform.controls.length.value) >= 25 || 
    parseFloat(this.ratereqform.controls.width.value) >= 7 || parseFloat(this.ratereqform.controls.height.value) >= 6 )
    {
      this.toastr.warning('Please Enter All the Required Fields.', 'Oops !');
       return;
    }
    else if(!this.ratereqform.controls.phoneNumber.value){
      this.toastr.warning('Please enter the phone number.', 'Oops !');
      return;
    }
      if ((this.ratereqform.controls.fromportid.value as any)?.id != (this.ratereqform.controls.toportid.value as any)?.id) {
        this.spinner.show();
        let currentUser = JSON.parse(String(localStorage.getItem('currentUser')));
        let model = new RateRequestVM();
        model.Id = parseInt(this.ratereqform.controls.id.value == "" ? 0 : (this.ratereqform.controls.id as any)?.value);
        model.FromCountryId = parseFloat((this.ratereqform.controls.fromcountryid.value as any)?.id);
        model.FromPortId = parseFloat((this.ratereqform.controls.fromportid.value as any)?.id);
        model.ToCountryId = parseFloat((this.ratereqform.controls.tocountryid.value as any)?.id);
        model.ToPortId = parseFloat((this.ratereqform.controls.toportid.value as any)?.id);
        let dateconvert = this.dateConvert(this.ratereqform.controls.whencancargolanport.value);
        //model.Whenportcanlanport = this.ratereqform.controls.whencancargolanport.value;
        model.Whenportcanlanport = new Date(dateconvert);
        model.CargoType = parseFloat((this.ratereqform.controls.cargoclass.value as any)?.id);
        model.Consigment = parseFloat((this.ratereqform.controls.cargoconsigment.value as any)?.id);
        model.Condition = parseFloat((this.ratereqform.controls.condition.value as any)?.value);
        model.CargoMovementStatus = parseFloat((this.ratereqform.controls.cargoMovementStatus.value as any)?.id);
        model.NoOfUnits = parseFloat(this.ratereqform.controls.noofunits.value);
        model.Length = parseFloat(this.ratereqform.controls.length.value);
        model.Width = parseFloat(this.ratereqform.controls.width.value);
        model.Height = parseFloat(this.ratereqform.controls.height.value);
        model.Weight = parseFloat(this.ratereqform.controls.weight.value);
        model.Sqm = parseFloat(this.ratereqform.controls.Sqm.value);
        model.Cbm = parseFloat(this.ratereqform.controls.cbm.value);
        model.UserId = currentUser? currentUser.usersDetailsVM.id:0;
        model.CreatedBy = currentUser?currentUser.usersDetailsVM.userId:0;
        model.Status = RaterequestStatus.AwaitingOffers;
        model.Cargodescription = this.ratereqform.controls.description.value;
        model.ShippingLineId = parseInt((this.ratereqform.controls.shippinglineId.value as any)?.shippingLineId);
        model.FileNames = this.fileNames;
        model.PhoneNumber= this.ratereqform.controls.phoneNumber.value;
        model.Email= this.ratereqform.controls.email.value;
        model.LastName= this.ratereqform.controls.lastname.value;
        model.FirstName= this.ratereqform.controls.firstname.value;
        this.raterequestservice.MakeRateRequest(model).subscribe((response: any) => {
          if (response != null && response.isSuccess == true && response.content != null) {
            // this.router.navigate(['/login']); 

            this.spinner.hide();
            this.router.navigate(['/raterequestlist']);
            this.toastr.success('Rate Request Has been Send Sucessfully..!', '');
          }
        })
      }
      else {
        this.toastr.error("Port should be different.", "Error");
      }

  }

  dateConvert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }
  getRatedetails() {
    this.raterequestservice.GetRateRequest(this.stateParams.id).subscribe((response: any) => {
      if (response != null && response.isSuccess == true && response.content != null) {
        let newDate = new Date(response.content[0].cargoLoadPortDate);
        this.ratereqform = this.fb.group({
          id: [response.content[0].id],
          fromcountryid: [response.content[0].fromCountryId],
          fromportid: [response.content[0].fromPortId],
          tocountryid: [response.content[0].toCountryId],
          toportid: [response.content[0].toPortId],
          whencancargolanport: [newDate],
          cargoclass: [response.content[0].cargoType],
          cargoconsigment: [response.content[0].cargoSegment],
          condition: [response.content[0].condition],
          cargoMovementStatus:[response.content[0].cargoMovementStatus],
          noofunits: [response.content[0].noOfUnits],
          length: [response.content[0].length],
          width: [response.content[0].width],
          height: [response.content[0].height],
          weight: [response.content[0].weight],
          Sqm: [response.content[0].sqm],
          cbm: [response.content[0].cbm],
          description: [response.content[0].cargopackageDescription],
          shippinglineId: [response.content[0].shippingLineId],
          phoneNumber: [response.content[0].userDetail.phoneNumber]
        }) as any;

        this.fileNames = response.content[0].fileNames;

        let cargoMovement = this.cargoMovementStatusList.filter(x => x.id == parseInt(response.content[0].cargoMovementStatus));
        this.ratereqform.controls.cargoMovementStatus.setValue(cargoMovement[0]);

        this.readonly = response.content[0].status == RaterequestStatus.AwaitingOffers ? false : true;
        let cargotype = this.cargoTypes.filter(x => x.id == parseInt(response.content[0].cargoType));
        this.ratereqform.controls.cargoclass.setValue(cargotype[0]);

        let cargosegment = this.cargoTypes.filter(x => x.id == parseInt(response.content[0].cargoType));
        this.ratereqform.controls.cargoclass.setValue(cargotype[0]);

        this.cargoSegments = this.cargoSegmentList.filter(x => x.cargoClassId == parseInt(response.content[0].cargoType));
        let cargosegselected = this.cargoSegments.filter(x => x.id == parseInt(response.content[0].cargoSegment));
        this.ratereqform.controls.cargoconsigment.setValue(cargosegselected[0]);

        let conditionselected: any = this.cargoConditions.filter(x => x.value == response.content[0].condition);
        this.ratereqform.controls.condition.setValue(conditionselected[0]);

        let shippingliselec = this.shippinglineslist.filter(x => x.shippingLineId == response.content[0].shippingLineId);
        this.ratereqform.controls.shippinglineId.setValue(shippingliselec[0]);

        var selectedFromCountry = this.countries.filter(x => x.id == response.content[0].fromCountryId);
        var selectedToCountry = this.countries.filter(x => x.id == response.content[0].toCountryId);

        this.ratereqform.controls.fromcountryid.setValue(selectedFromCountry[0]);
        this.ratereqform.controls.tocountryid.setValue(selectedToCountry[0]);

        this.portservice.GetPortByCountryId(response.content[0].fromCountryId).
          subscribe((response: any) => {
            if (response != null && response.content != null) {
              this.fromport = response.content;
              var selectedFromport = this.fromport.filter(x => x.id == this.ratereqform.controls.fromportid.value);
              this.ratereqform.controls.fromportid.setValue(selectedFromport[0]);
            }
          });
        this.portservice.GetPortByCountryId(response.content[0].toCountryId).
          subscribe((response: any) => {
            if (response != null && response.content != null) {
              this.toport = response.content;
              var selectedtoport = this.toport.filter(x => x.id == this.ratereqform.controls.toportid.value);
              this.ratereqform.controls.toportid.setValue(selectedtoport[0]);
            }
          });

      }
      else {
        this.toastr.error('Something went wrong!', 'Oops!!');
      }
    });
  }

  calculateSQM(event,name) {
    if(name != "")
    {
      if(name == 'length')
      {
        this.lengthvalid  =  parseFloat(event.target.value) <= 25 ? false: true;
      } 
      else if(name == 'width')
      {
        this.widthvalid  =  parseFloat(event.target.value) <= 7 ? false: true;
      } 
      else{

      }  
    }
   // console.log('datat',event)
    let SQM: any = (this.ratereqform.controls.length as any)?.value * (this.ratereqform.controls.width as any)?.value * (this.ratereqform.controls.noofunits as any)?.value;
    this.ratereqform.controls.Sqm.setValue(SQM.toFixed(2));
    this.calulateCBM();
  }

  calulateCBM() {
   this.heightvalid =  (this.ratereqform.controls.height as any)?.value <= 6 ?false : true;
    let cbm = (this.ratereqform.controls.length as any)?.value * (this.ratereqform.controls.width as any)?.value
      * (this.ratereqform.controls.height as any)?.value * (this.ratereqform.controls.noofunits as any)?.value;
    this.ratereqform.controls.cbm.setValue(cbm.toFixed(2));
  }

  FixedNumber() {
    this.ratereqform.controls.noofunits.setValue((this.ratereqform.controls.noofunits.value as any)?.toFixed(0.00))
    this.calculateSQM(event,"");
  }

  ngAfterViewInit() {
    $(document).on('keydown', 'input[pattern]', function (e) {
      var input = $(this);
      var oldVal = input.val();
      var regex = new RegExp(input.attr('pattern'), 'g');
      setTimeout(function () {
        var newVal = input.val();
        if (!regex.test(newVal)) {
          input.val(oldVal);
        }
      }, 0);
    });
  }

  getshippingline() {
    this.portservice.GetShippingLines().subscribe((response: any) => {
      if (response != null && response.content != null) {
        this.shippinglineslist = response.content;
        if (this.stateParams != null && this.stateParams.shipId > 0) {
          var id = parseInt(this.stateParams.shipId);
          var selectedShips = this.shippinglineslist.filter(x => x.shippingLineId == id);
          this.ratereqform.controls.shippinglineId.setValue(selectedShips[0]);
        }
      } else {
        this.shippinglineslist = null;
      }
    });
  }

  public fileOver(event) {
    console.log(event);
  }

  public fileLeave(event) {
    console.log(event);
  }
  
  onFileDropped(files: NgxFileDropEntry[]) {
    this.formData = new FormData();

    if((this.fileNames == null && files.length>3) 
    || (this.fileNames != null && this.fileNames.length>=3) 
    || (this.fileNames != null && (this.fileNames.length+files.length))>3){
      this.toastr.error('Max 3 files allowed.', 'error');
      return;
    }

    for (const droppedFile of files){
      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;

          fileEntry.file((file: File) => {

            this.formData.append(fileEntry.name, file);
            this.spinner.show();
            this.http.post<any>(this.getUrl(`api/Upload/UploadFreightDocuments`), this.formData, { responseType: 'json' })
              .pipe()
              .subscribe(
                (response: any) => {
                  if (response != null) {
                    if (response != null && response.isSuccess && response.content != null) {
                      this.toastr.success('File Upload Sucessfully', 'Success');
                      if(this.fileNames==null){
                        this.fileNames=[];
                      }
                      this.fileNames.push(response.content);
                      //this.isFileUpload = true;
                    }
                  }
                  this.spinner.hide();
                },
                (err: HttpErrorResponse) => {
                  this.spinner.hide();
                });
          });
       
      }
      else{
        const fileEntry = droppedFile.fileEntry as FileSystemDirectoryEntry;
      }
    }

  }

  getUrl(url: string): string {
    return environment.apiUrl + url;
  }

  // validationevent()
  // {
  // alert();
  // }
}
